import React, { Component } from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';
import { get, isEqual } from 'lodash';

class JobTimeDetails extends Component {
	shouldComponentUpdate({ job, points, timeZoneId }) {
		const lastProps = this.props;
		return (
			!isEqual(job, lastProps.job)
			|| !isEqual(points, lastProps.points)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
		);
	}

	render() {
		const { job, points, timeZoneId } = this.props;

		const checkinTime = get(points.find((item) => item.type === 'checkin'), 'dateTime', null);
		const checkoutTime = get(points.find((item) => item.type === 'checkout'), 'dateTime', null);

		return (
			<div className="flex flex-wrap">
				<div className="margin-right-100 margin-bottom-10">
					<div className="margin-bottom-10 font-size-16">Scheduled Time</div>
					<ul className="timeline">
						<li className="bullet-12 padding-bottom-10 padding-left-10">
							<div>Scheduled/Start</div>
							<div className="simple-text">{ utils.parseUTCDateToTimeZone(job.startDateTime, timeZoneId).format('h:mm a') }</div>
						</li>
						<li className="bullet-12 padding-left-10">
							<div>Scheduled/End</div>
							<div className="simple-text">{ utils.parseUTCDateToTimeZone(job.endDateTime, timeZoneId).format('h:mm a') }</div>
						</li>
					</ul>
				</div>
				<div className="margin-right-100 margin-bottom-10">
					<div className="margin-bottom-10 font-size-16">Clock In/Out</div>
					<ul className="timeline">
						<li className="bullet-12 bullet-yellow padding-bottom-10 padding-left-10">
							<div>Clock In</div>
							<div className="simple-text">{ checkinTime ? utils.parseUTCDateToTimeZone(checkinTime, timeZoneId).format('h:mm a') : '--' }</div>
						</li>
						<li className="bullet-12 bullet-red padding-left-10">
							<div>Clock Out</div>
							<div className="simple-text">{ checkoutTime ? utils.parseUTCDateToTimeZone(checkoutTime, timeZoneId).format('h:mm a') : '--' }</div>
						</li>
					</ul>
				</div>
			</div>
		);
	}
}

JobTimeDetails.propTypes = {
	job        : PropTypes.object,
	points     : PropTypes.array,
	timeZoneId : PropTypes.string,
};

JobTimeDetails.defaultProps = {
	job        : {},
	points     : [],
	timeZoneId : '',
};

export default JobTimeDetails;
